import rbaOrdnung from '../../../../static/documents/ordnungen/240516 RBA Ordnung.pdf';
import lizenzOrdnung from '../../../../static/documents/ordnungen/2503_Lizenzordnung.pdf';
import spielOrdnung from '../../../../static/documents/ordnungen/2503_Spielordnung.pdf';
import durchfuehrungsrichtlinie from '../../../../static/documents/richtlinien/2026-06 Durchführungsrichtlinie Bundesliga Herren.pdf';
import lizenz2025 from '../../../../static/documents/lizenzvergabe/anonymisierte Tabelle.xlsx - Google Sheets - Übersicht Lizenzvergabe 2025_2026 anonymisierte Tabelle.pdf';
import rbaHdAntraege from '../../../../static/documents/sitzungen/250111 Antrräge RBA Sitzung HD.pdf';
import rbaHdProtokoll from '../../../../static/documents/sitzungen/250111 Protokoll - RBA HD.pdf';
import rbaBerlinAntraege from '../../../../static/documents/sitzungen/250719 Anträge RBA Sitzung Berlin.pdf';
import rbaBerlinProtokoll from '../../../../static/documents/sitzungen/250719 Protokoll RBA Sitzung Berlin.pdf';
import rbaOnlineAntraege from '../../../../static/documents/sitzungen/260110 Anträge RBA Sitzung Online.pdf';
import rbaOnlineProtokoll from '../../../../static/documents/sitzungen/260110 Protokoll RBA_Sitzung Online.pdf';
import rbaHannoverTagesordnung from '../../../../static/documents/sitzungen/260613 Tagesordnung RBA Sitzung Hannover.pdf';
import rbaHannoverAntraege from '../../../../static/documents/sitzungen/260613 Anträge RBA Sitzung Hannover.pdf';
import rbaHannoverProtokoll from '../../../../static/documents/sitzungen/260613 Protokoll RBA Sitzung Hannover.pdf';

import './Downloads.css';

const AboutDownloads = () => {
  return (
    <div className="about-download">

      <div className="about-struktur__section-header">
        <h2>ORDNUNGEN</h2>
      </div>

      <table className="regulations-table">
        <tbody>
          <tr>
            <td>RBA ORDNUNG</td>
            <td>Stand 16.05.2024</td>
            <td><a href={rbaOrdnung} className="download-link" download="240516 RBA Ordnung.pdf" >DOWNLOAD</a></td>
          </tr>
          <tr>
            <td>SPIELORDNUNG</td>
            <td>Stand 04/2024</td>
            <td><a href={spielOrdnung} download="2503_Spielordnung.pdf" className="download-link">DOWNLOAD</a></td>
          </tr>
          <tr>
            <td>LIZENZORDNUNG</td>
            <td>Stand 01.05.2025</td>
            <td><a href={lizenzOrdnung} download="2503 Lizenzordnung.pdf" className="download-link">DOWNLOAD</a></td>
          </tr>
        </tbody>
      </table>

      <div className="about-struktur__section-header">
        <h2>RICHTLINIEN</h2>
      </div>

      <table className="regulations-table">
        <tbody>
          <tr>
            <td>DURCHFÜHRUNG</td>
            <td>Stand 06/2026</td>
            <td><a href={durchfuehrungsrichtlinie} download="2026-06 Durchführungsrichtlinie Bundesliga Herren.pdf" className="download-link">DOWNLOAD</a></td>
          </tr>
        </tbody>
      </table>

      <div className="about-struktur__section-header">
        <h2>LIZENZVERGABE</h2>
      </div>

      <table className="regulations-table">
        <tbody>
          <tr>
            <td>2025</td>
            <td>Stand 03.07.2025</td>
            <td><a href={lizenz2025} download="anonymisierte Tabelle.xlsx - Google Sheets - Übersicht Lizenzvergabe 2025_2026 anonymisierte Tabelle.pdf" className="download-link">DOWNLOAD</a></td>
          </tr>
        </tbody>
      </table>

      <div className="about-struktur__section-header">
        <h2>SITZUNGSPROTOKOLLE</h2>
      </div>

      <table className="regulations-table">
        <tbody>
          <tr>
            <td>11.01.2025</td>
            <td>Anträge</td>
            <td>
              <a
                href={rbaHdAntraege}
                className="download-link"
                download="250111 Anträge RBA Sitzung HD.pdf"
              >
                DOWNLOAD
              </a>
            </td>
          </tr>
          <tr>
            <td>11.01.2025</td>
            <td>Protokoll</td>
            <td>
              <a
                href={rbaHdProtokoll}
                className="download-link"
                download="250111 Protokoll RBA Sitzung HD.pdf"
              >
                DOWNLOAD
              </a>
            </td>
          </tr>

          <tr>
            <td>19.07.2025</td>
            <td>Anträge</td>
            <td>
              <a
                href={rbaBerlinAntraege}
                className="download-link"
                download="250719 Anträge RBA Sitzung Berlin.pdf"
              >
                DOWNLOAD
              </a>
            </td>
          </tr>
          <tr>
            <td>19.07.2025</td>
            <td>Protokoll</td>
            <td>
              <a
                href={rbaBerlinProtokoll}
                className="download-link"
                download="250719 Protokoll RBA Sitzung Berlin.pdf"
              >
                DOWNLOAD
              </a>
            </td>
          </tr>

          <tr>
            <td>10.01.2026</td>
            <td>Anträge</td>
            <td>
              <a
                href={rbaOnlineAntraege}
                className="download-link"
                download="260110 Anträge RBA Sitzung Online.pdf"
              >
                DOWNLOAD
              </a>
            </td>
          </tr>
          <tr>
            <td>10.01.2026</td>
            <td>Protokoll</td>
            <td>
              <a
                href={rbaOnlineProtokoll}
                className="download-link"
                download="260110 Protokoll RBA Sitzung Online.pdf"
              >
                DOWNLOAD
              </a>
            </td>
          </tr>

          <tr>
            <td>13.06.2026</td>
            <td>Tagesordnung</td>
            <td>
              <a
                href={rbaHannoverTagesordnung}
                className="download-link"
                download="260613 Tagesordnung RBA Sitzung Hannover.pdf"
              >
                DOWNLOAD
              </a>
            </td>
          </tr>
          <tr>
            <td>13.06.2026</td>
            <td>Anträge</td>
            <td>
              <a
                href={rbaHannoverAntraege}
                className="download-link"
                download="260613 Anträge RBA Sitzung Hannover.pdf"
              >
                DOWNLOAD
              </a>
            </td>
          </tr>
          <tr>
            <td>13.06.2026</td>
            <td>Protokoll</td>
            <td>
              <a
                href={rbaHannoverProtokoll}
                className="download-link"
                download="260613 Protokoll RBA Sitzung Hannover.pdf"
              >
                DOWNLOAD
              </a>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  )
}

export default AboutDownloads;
